import React from 'react';
import { useSync } from '../../context/SyncContext';

export const OfflineIndicator: React.FC = () => {
    const { isOnline, isSyncing, pendingCount, forceSync } = useSync();

    if (isOnline && pendingCount === 0) {
        return null; // No mostrar nada si está online y no hay pendientes
    }

    return (
        <div className="fixed bottom-4 right-4 z-50">
            <div className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg ${isOnline ? 'bg-blue-600' : 'bg-orange-600'
                } text-white`}>
                {!isOnline && (
                    <>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414" />
                        </svg>
                        <span className="font-medium">Modo Offline</span>
                    </>
                )}

                {isSyncing && (
                    <>
                        <svg className="w-5 h-5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        <span className="font-medium">Sincronizando...</span>
                    </>
                )}

                {pendingCount > 0 && !isSyncing && (
                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                            <span className="text-sm">{pendingCount} pendiente{pendingCount > 1 ? 's' : ''}</span>
                        </div>
                        <button
                            onClick={() => forceSync()}
                            className="bg-white/20 hover:bg-white/30 px-2 py-1 rounded text-xs transition-colors font-semibold"
                        >
                            Sincronizar ahora
                        </button>
                    </div>
                )}

                {pendingCount === 0 && isOnline && !isSyncing && (
                    <button
                        onClick={() => forceSync()}
                        className="flex items-center gap-2 hover:opacity-80 transition-opacity"
                        title="Sincronizar ahora"
                    >
                        <i className="ri-refresh-line"></i>
                        <span className="text-sm font-medium">Sincronizar</span>
                    </button>
                )}
            </div>
        </div>
    );
};
